// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Main_mainWrapper__EewMC","bottomCopyright":"Main_bottomCopyright__31WrI","LoginFooter":"Main_LoginFooter__U4n4P"};